import React from 'react';
import dynamic from 'next/dynamic';
import BasicLayout from 'src/layouts/basic';
import PageLoading from 'src/components/PageLoading';
import { withPermissionCheck } from 'src/components/HOC';
import { REPORTS_SALES } from 'src/consts/permissionCodes';

const DashboardContent = dynamic(() => import('../../components/Dashboard/Dashboard'), {
  ssr: false,
  loading: () => <PageLoading absoluteCenter background="transparent" />,
});

const Dashboard = () => (
  <BasicLayout>
    <DashboardContent />
  </BasicLayout>
);

export default withPermissionCheck(Dashboard, { permissionCode: REPORTS_SALES });
